import { ECountries } from '@/models/internationalization';

export class ManagerState {
  constructor(public info: Manager, public business: IBusiness[]) {}
}

export interface IBusiness {
  id: string;
  name: string;
  type: string;
  country: ECountries;
  countryIso2: string;
  providers: {
    name: string;
  }[];
  logo: {
    publicPath: {
      small: string;
    };
  };
}

export interface Manager {
  username?: string;
  authType?: 'manager' | 'super-admin';
  extraInfo?: ExtraInfo;
  sub?: string;
  iat?: number;
  exp?: number;
}

interface ExtraInfo {
  fullname: string;
  mail: string;
  role: Roles;
  requireBusiness: boolean;
  business: Business;
  isImpersonated: boolean;
  impersonator: string | null;
}

interface Business {
  id: string;
  name: string;
}

type Roles = 'owner' | 'manager';
